import React, { useState } from "react";
import MiniDrawer from "../../components/Menu/Drawer";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import IconMenu from "../../components/subMenu/SubMenu";
import { Paper } from "@mui/material";
import { Routes, Route, useParams, useLocation } from "react-router-dom";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import Pdf from "../../components/pdf/Pdf";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import useSave from "../../Hooks/useSave";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { useEffect } from "react";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import InteractiveReports from "../InteractiveReports/InteractiveReports";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { DateTime } from "luxon";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Report from "./Report";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: "50px",
  },
  header: {
    fontSize: "24",
    display: "flex",
    flexDirection: "row",
    // margin: "0px 50px 10px 50px",
    borderBottom: "2pt solid black",
  },
  words: {
    margin: "5px",
  },
  word1: {
    margin: "5px",
    width: "70%",
  },
  word2: {
    margin: "5px",
    width: "10%",
    textAlign: "right",
  },
  word3: {
    margin: "5px",
    width: "20%",
  },
  section: {
    borderBottom: "1pt dashed black",
    margin: "0px 20px",
    paddingBottom: "5px",
    display: "flex",
    flexDirection: "column",
  },
  section2: {
    fontSize: "14",
    // margin: "0px 52px",
    display: "flex",
    flexDirection: "row",
  },
  item1: {
    marginLeft: "25px",
    fontSize: "12",
    fontWeight: "200",
    width: "140px",
  },
  item2: {
    marginLeft: "25px",
    fontSize: "12",
    width: "30px",
    fontWeight: "200",
    textAlign: "right",
  },
  item3: {
    marginLeft: "5px",
    fontSize: "12",
    width: "90px",
    fontWeight: "200",
  },
});

const menuHeader = {
  icon: <SettingsOutlinedIcon sx={{ color: "white" }} fontSize="small" />,
  name: "Reports",
};

function sortByThenBy(a, b, thenBy, order) {
  if (order === "asc" || !order) {
    if (!a && !b) return thenBy || 0;
    if (!a) return -1;
    if (!b) return +1;

    return a.localeCompare(b) || thenBy || 0;
  } else if (order === "desc") {
    if (!a && !b) return thenBy || 0;
    if (!a) return +1;
    if (!b) return -1;

    return b.localeCompare(a) || thenBy || 0;
  }
}

function Reports() {
  const [orderedProducts, setOrderedProducts] = useState();
  const { fetchGraphql, DialogSave } = useSave();
  const [data, setData] = useState([]);
  const [productProductionSheets, setProductProductionSheets] = useState([]);
  const { sheet } = useParams();
  const location = useLocation();
  const [reportType, setReportType] = useState("pdf");
  const [loading, isLoading] = useState(false);
  const [done, setDone] = useState(false);

  const menu = productProductionSheets.map((item) => ({
    link: `/reports/${item}`,
    name: item,
  }));

  useEffect(() => {
    fetchGraphql({
      query: `
        query productProductionSheets {
          productProductionSheets
        }`,
    }).then((result) => {
      setProductProductionSheets(result.data.productProductionSheets);
    });
  }, []);

  //create date
  const date = new Date();
  const tomorow = new Date(date);
  tomorow.setDate(date.getDate() + 1);

  const [fromDate, setFromDate] = useState(
    DateTime.now().plus({ day: 1 }).toISO()
  );

  const groupBy = (items, key) =>
    items.reduce(
      (result, item) => ({
        ...result,
        [item[key]]: [...(result[item[key]] || []), item],
      }),
      {}
    );

  useEffect(() => {
    isLoading(true);

    fetchGraphql({
      query: `query OrderedProducts($deliveryDate: String, $productionSheet: String, $orderStatus: [String]) {
        orderedProducts(deliveryDate: $deliveryDate, productionSheet: $productionSheet, orderStatus: $orderStatus) {
          unitOfMeasure
          quantity
          groupQuantity
          productName
          productCategory
          productSubCategory
          groupCode
          groupName
          productId
          groupUnitOfMeasure
          deliveryDate
        }
      }`,
      variables: {
        deliveryDate: fromDate,
        productionSheet: sheet,
        orderStatus: done ? ["Done", "Submited"] : ["Submited"],
      },
    }).then((result) => {
      const items = result.data.orderedProducts.map((item, index) => {
        if (!item.groupCode) {
          return { ...item, groupCode: index };
        } else {
          return { ...item };
        }
      });

      const groupedItems = groupBy(items, "groupCode");

      // console.log(result, groupedItems);

      setOrderedProducts(groupedItems);

      isLoading(false);
    });
  }, [fromDate, location, done]);

  const handleReportType = (event, newReportType) => {
    setReportType(newReportType);
  };

  const handleDone = (event, value) => {
    setDone(value);
    console.log(value);
  };

  try {
    return (
      <MiniDrawer>
        {() => (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              height: "100%",
            }}
          >
            <DialogSave />

            <Box>
              <IconMenu menuHeader={menuHeader} menu={menu} />

              <Box sx={{ marginTop: "20px" }}>
                <LocalizationProvider dateAdapter={AdapterLuxon}>
                  <DatePicker
                    label="Delivery Date"
                    openTo="day"
                    views={["year", "month", "day"]}
                    shouldDisableDate={(date) => {
                      const today = new Date();
                      const todayDate = new Date(date);

                      // if (date < today.setDate(today.getDate() - 1)) return true;

                      // if (todayDate.getDay() === 6) return true;
                    }}
                    value={fromDate || tomorow}
                    onChange={(newValue) => {
                      console.log(newValue);
                      setFromDate(newValue.toISO());
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Box>

              <Box sx={{ marginTop: "20px" }}>
                <ToggleButtonGroup
                  value={reportType}
                  exclusive
                  onChange={handleReportType}
                  aria-label="text alignment"
                >
                  <ToggleButton value="pdf" aria-label="left aligned">
                    PDF
                  </ToggleButton>
                  <ToggleButton value="interactive" aria-label="centered">
                    Interactive
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
              <Box sx={{ marginTop: "20px" }}>
                <ToggleButtonGroup
                  value={done}
                  exclusive
                  onChange={handleDone}
                  aria-label="text alignment"
                >
                  <ToggleButton value={false} aria-label="left aligned">
                    Not Done
                  </ToggleButton>
                  <ToggleButton value={true} aria-label="centered">
                    All
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
            </Box>

            <Paper
              sx={{
                width: "100%",
                marginLeft: "20px",
                padding: "20px",
                overflow: "auto",
              }}
            >
              <Routes>
                <Route
                  path="/packaging"
                  element={<Button variant="contained">Back</Button>}
                />
                <Route
                  path="/*"
                  element={
                    reportType === "interactive" ? (
                      <InteractiveReports fromDate={fromDate} done={done}/>
                    ) : (
                      <>
                        <PDFDownloadLink
                          document={
                            <Report
                              orderedProducts={orderedProducts}
                              sheet={sheet}
                              fromDate={fromDate}
                            />
                          }
                          fileName={"id"}
                        >
                          {({ blob, url, loading, error }) => {
                            return loading ? (
                              <Backdrop
                                sx={{
                                  color: "#fff",
                                  zIndex: (theme) => theme.zIndex.drawer + 1,
                                }}
                                open={isLoading}
                                // onClick={handleClose}
                              >
                                <CircularProgress color="inherit" />
                              </Backdrop>
                            ) : (
                              // "Loading document..."
                              <Button
                                onClick={(e) => {
                                  e.stopPropagation();

                                  e.preventDefault();

                                  const newblob = new Blob([blob], {
                                    type: "application/pdf",
                                  });

                                  const newWindow = window.open(
                                    URL.createObjectURL(newblob)
                                  );

                                  setTimeout(() => newWindow.print(), 1000);
                                }}
                              >
                                Print
                              </Button>
                            );
                          }}
                        </PDFDownloadLink>

                        <PDFViewer width="100%" height="100%">
                          <Report
                            orderedProducts={orderedProducts}
                            sheet={sheet}
                            fromDate={fromDate}
                          />
                        </PDFViewer>
                      </>
                    )
                  }
                />
              </Routes>
            </Paper>
          </Box>
        )}
      </MiniDrawer>
    );
  } catch (error) {
    console.log(error);
  }
}

export default Reports;
